<template>
  <button
    class="button-style"
    :style="style"
    :class="[size, type]"
    @click.stop="ClickBtn">{{title}}</button>
</template>

<script>
  export default {
    props: {
      title: {
        type: null,
        default: '标题'
      },
      size: {
        type: String,
        default: 'lg'
      },
      type: {
        type: String,
        default: 'primary'
      },
      width: {
        type: null,
        default: '100%'
      }
    },
    methods: {
      ClickBtn () {
        this.$emit('click')
        this.$emit('clickBtn')
      }
    },
    computed: {
      style () {
        return `width: ${this.width}`
      }
    }
  }
</script>

<style lang="less" scoped>
  .button-style {
    .c(#ffffff);
    box-sizing: border-box;
    .flex-ccc();
    &:active {
      opacity: 0.8;
    }

    /**
     * 处理色彩显示
     */
    &.primary {
      background-image: linear-gradient(270deg,
        #00b0f4 0%,
        #3fc9ff 100%),
      linear-gradient(
        #c4c4c4,
        #c4c4c4);
      background-blend-mode: normal,
        normal;
      box-shadow: 0rem 0.06rem 0.14rem 0rem
        rgba(0, 154, 214, 0.2);
    }
    &.hollow {
      .bg(#fff);
      border: 1px solid #c4c4c4;
      .c(#999);
    }
    &.light {
      .bg(#ebf9fd);
      .c(#00b0f4);
    }

    /**
     * 处理大小尺寸
     */
    &.lg {
      .h(.8rem);
      .br(.4rem);
      .fz(.32rem);
    }
    &.md {
      .h(.6rem);
      .br(.3rem);
      .fz(.24rem);
    }
  }
</style>
